export const SHORTEN_URL_REQUEST = "SHORTEN_URL_REQUEST" as const;
export const SHORTEN_URL_SUCCESS = "SHORTEN_URL_SUCCESS" as const;
export const SHORTEN_URL_FAILURE = "SHORTEN_URL_FAILURE" as const;

export interface UrlShortenerData {
  status?: string;
  shorturl: string;
  longUrl: string;
}

export interface UrlShortenerParams {
  usageId: string;
  partnerCode: string;
  sessionId?: string;
  rtName?: string;
  language?: string;
}

export interface ShortenUrlRequestAction {
  type: typeof SHORTEN_URL_REQUEST;
  payload: UrlShortenerParams;
}

export interface ShortenUrlSuccessAction {
  type: typeof SHORTEN_URL_SUCCESS;
  payload: UrlShortenerData;
}

export interface ShortenUrlFailurePayload {
  error: string;
  longUrl?: string;
}

export interface ShortenUrlFailureAction {
  type: typeof SHORTEN_URL_FAILURE;
  payload: ShortenUrlFailurePayload;
}

export type UrlShortenerActionTypes =
  | ShortenUrlRequestAction
  | ShortenUrlSuccessAction
  | ShortenUrlFailureAction;


export const shortenUrlRequest = (
  params: UrlShortenerParams
): ShortenUrlRequestAction =>
  ({
    type: SHORTEN_URL_REQUEST,
    payload: params,
  } as const);

export const shortenUrlSuccess = (
  data: UrlShortenerData
): ShortenUrlSuccessAction =>
  ({
    type: SHORTEN_URL_SUCCESS,
    payload: data,
  } as const);

export const shortenUrlFailure = (
  error: string,
  longUrl?: string
): ShortenUrlFailureAction =>
  ({
    type: SHORTEN_URL_FAILURE,
    payload: { error, longUrl },
  } as const);
